import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.288 14.775 17.763 6.3c.2-.2.433-.3.7-.3.267 0 .5.1.7.3.2.2.3.438.3.713 0 .274-.1.512-.3.712l-9.175 9.2c-.2.2-.433.3-.7.3a.96.96 0 0 1-.7-.3l-4.3-4.3A.93.93 0 0 1 4 11.912a1.02 1.02 0 0 1 .313-.712c.2-.2.438-.3.713-.3.275 0 .512.1.712.3l3.55 3.575Z" }));
const ForwardRef = forwardRef(SvgCheck);
export default ForwardRef;
